import {alias, createModelSchema, custom, deserialize, list, primitive, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {ItemStateAction} from "./ItemStateAction";
import {JobModel} from "../worker/jobs/JobModel";
import {ItemStateNotice} from "@/modules/redactor/models/item/ItemStateNotice";

export class ItemStateConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemStateConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemStateConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._start = ItemStateAction.NONE;
        this._finish = ItemStateAction.NONE;
        this._notice = ItemStateNotice.NONE;
        this._repeat = false;
        this._values = [];
    }

    get start() {
        return this._start;
    }

    set start(value) {
        this._start = value;
    }

    get finish() {
        return this._finish;
    }

    set finish(value) {
        this._finish = value;
    }

    get notice() {
        return this._notice;
    }

    set notice(value) {
        this._notice = value;
    }

    get repeat() {
        return this._repeat;
    }

    set repeat(value) {
        this._repeat = value;
    }

    get values() {
        return this._values;
    }

    set values(value) {
        this._values = value;
    }

    valid() {

        if (!ItemStateAction.is(this.start)) {
            return false;
        }

        if (!ItemStateAction.is(this.finish)) {
            return false;
        }

        if (!ItemStateNotice.is(this.notice)) {
            return false;
        }

        if (!this.values || this.values.some(v => !v || !v.valid())) {
            return false;
        }

        if(!this.start || !this.finish){
            return false;
        }

        if (this.values.length === 0 && ItemStateAction.isNone(this.start) && ItemStateAction.isNone(this.finish) && ItemStateNotice.isNone(this.notice)) {
            return false;
        }

        return true;
    }

    empty() {
        return this.values.length === 0 &&
            ItemStateAction.isNone(this.start) &&
            ItemStateAction.isNone(this.finish) &&
            ItemStateNotice.isNone(this.notice)
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemStateConfig());
        } else if (target instanceof ItemStateConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemStateConfig, {
    _start: alias("start", ItemStateAction.schema()),
    _finish: alias("finish", ItemStateAction.schema()),
    _notice: alias("notice", ItemStateNotice.schema()),
    _repeat: alias("repeat", primitive()), /* don't change to Schema.primitive() */
    _values: alias("data", list(JobModel.schema())),
});
